@if (value()) {
  <app-branches-form
    [edit]="false"
    [create]="false"
    [delete]="true"
    [details]="true"
    [value]="value()"
    [access]="access()"
  ></app-branches-form>
}
